import React, { useState, useEffect, useContext } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Tooltip,
  Typography,
  CardContent,
  Card,
  Grid,
  Box,
  styled,
  tableCellClasses,
  Button,
  Popover,
} from "@mui/material";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteConfirmationModal from "../deleteConfirmationModal";
import AppContext from "../context/context";
import CustomTypography from "../../globalStyles/fonts";
import { toast } from "react-toastify";
import { freightBrokerService } from "../../utils/services/freightBrokerService";
import FreightBrokerDetailsModal from "../freightBrokerDetailsModal";
import { isMobile } from "../../globalStyles/mobile";
import CustomPagination from "../pagination";
import { useTheme } from "@mui/styles";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ViewIcon from "../../globalStyles/icons/vieewIcon";
import DeleteIcon from "../../globalStyles/icons/deleteIcon";
import EditIcon from "../../globalStyles/icons/editIcon";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "var(--table-header-bg)",
    border: "1px solid var(--border-color)",
    padding: "4px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    padding: "4px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "var(--bg-paper)",
    border: "1px solid var(--border-color)",
  },
  "&:nth-of-type(even)": {
    backgroundColor: "var(--bg-secondary)",
    border: "1px solid var(--border-color)",
  },
  "&:lastChild td, &:lastChild th": {
    border: 0,
  },
}));

const FreightBrokerList = ({
  viewMode,
  data,
  onEditData,
  onDeleteData,
  setPage,
  setRowsPerPage,
  rowsPerPage,
  page,
  dataCount,
  selectedFreightBroker,
  setSelectedFreightBroker,
}) => {
  const [deletingItemId, setDeletingItemId] = useState(null);
  const [frieightBrokerData, setFreightBrokerData] = useState([]);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const { user } = useContext(AppContext);
  const [openViewModal, setOpenViewModal] = useState(false);
  const theme = useTheme();
  const defaultColor = "#D13438";
  const primary_color = theme.palette?.primary?.main || defaultColor;
  const [anchorElPopover, setAnchorElPopover] = useState(null);
  const openPopover = Boolean(anchorElPopover);
  const startIndex = page * rowsPerPage;

  const deleteData = async () => {
    try {
      await freightBrokerService.delete(deletingItemId);
      setOpenConfirmation(false);
      onDeleteData && onDeleteData();
      toast.success("Freight Broker deleted Successfully.");
    } catch (error) {
      console.error("Delete failed:", error);
    }
  };
  const handleViewClick = (e) => {
    setSelectedFreightBroker(e);
    setOpenViewModal(true);
  };
  const handlePopoverOpen = (event, item) => {
    setSelectedFreightBroker(item);
    event.stopPropagation();
    setAnchorElPopover(event.currentTarget);
  };
  const handlePopoverClose = () => {
    setAnchorElPopover(null);
  };
  useEffect(() => {
    setFreightBrokerData(
      data?.map((item) => ({
        ...item,
        action: (
          <Box sx={{ display: "flex", boxShadow: "none" }}>
            <IconButton
              aria-label="more actions"
              onClick={(e) => handlePopoverOpen(e, item)}
              sx={{
                color: openPopover ? "primary" : "inherit",
              }}
            >
              <MoreVertIcon />
            </IconButton>
            <Popover
              open={Boolean(anchorElPopover)}
              anchorEl={anchorElPopover}
              onClose={handlePopoverClose}
              anchorOrigin={{
                vertical: isMobile() ? "bottom" : "top",
                horizontal: isMobile() ? "center" : "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              sx={{
                "& .MuiPaper-root": {
                  boxShadow: "none",
                  border: "1px solid var(--border-color)",
                  borderRadius: "4px",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  padding: "10px",
                  boxShadow: "none",
                  gap: 1,
                }}
              >
                <Button
                  style={{
                    color: "var(--text-tertiary)",
                    justifyContent: "flex-start",
                    textTransform: "none",
                  }}
                  onClick={() => handleViewClick(item)}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="flex-start"
                    width="100%"
                    gap={1}
                  >
                    <ViewIcon />
                    <Typography
                      fontFamily={"poppins"}
                      fontSize={"16px"}
                      color={"var(--text-tertiary)"}
                      fontWeight={500}
                    >
                      View
                    </Typography>
                  </Box>
                </Button>

                <Button
                  style={{
                    color: "var(--text-tertiary)",
                    justifyContent: "flex-start",
                    textTransform: "none",
                  }}
                  onClick={() =>
                    onEditData && onEditData(selectedFreightBroker)
                  }
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="flex-start"
                    width="100%"
                    gap={1}
                  >
                    <EditIcon />
                    <Typography
                      fontFamily={"poppins"}
                      fontSize={"16px"}
                      color={"var(--text-tertiary)"}
                      fontWeight={500}
                    >
                      Edit
                    </Typography>
                  </Box>
                </Button>
                <Button
                  style={{
                    color: "var(--text-tertiary)",
                    justifyContent: "flex-start",
                    textTransform: "none",
                  }}
                  onClick={() => {
                    // setSelectedCustomProvider(item);
                    setDeletingItemId(item._id);
                    setOpenConfirmation(true);
                  }}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="flex-start"
                    width="100%"
                    gap={1}
                  >
                    <DeleteIcon />
                    <Typography
                      fontFamily={"poppins"}
                      fontSize={"16px"}
                      color={"var(--text-tertiary)"}
                      fontWeight={500}
                    >
                      Delete
                    </Typography>
                  </Box>
                </Button>
              </Box>
            </Popover>
          </Box>
        ),
      })),
    );
  }, [data, anchorElPopover]);
  // useEffect(() => {
  //   setFreightBrokerData(
  //     data?.map((item) => ({
  //       ...item,
  //       action: (
  //         <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
  //           <IconButton
  //             style={{
  //               color: "#007DFF",
  //               padding: 0,
  //               background: "#C3E1FF",
  //               height: 30,
  //               width: 30,
  //               borderRadius: 5,
  //               boxShadow: "0px 0px 4px 0px #00000040",
  //             }}
  //             aria-label="view"
  //             onClick={() => {
  //               handleViewClick(item);
  //             }}
  //           >
  //             <img
  //               style={{ height: 14, width: 20 }}
  //               alt="view"
  //               src="/eye.png"
  //             ></img>
  //           </IconButton>

  //           {user.role == "admin" ? (
  //             <>
  //               <IconButton
  //                 onClick={() => onEditData && onEditData(item)}
  //                 style={{
  //                   color: "#FEC50F",
  //                   padding: 0,
  //                   background: "#FEC50F33",
  //                   height: 30,
  //                   width: 30,
  //                   borderRadius: 5,
  //                   boxShadow: "0px 0px 4px 0px #00000040",
  //                 }}
  //               >
  //                 <BorderColorIcon sx={{ height: 20, width: 20 }} />
  //               </IconButton>
  //               <IconButton
  //                 onClick={() => {
  //                   setSelectedFreightBroker(item);
  //                   setDeletingItemId(item._id);
  //                   setOpenConfirmation(true);
  //                 }}
  //                 style={{
  //                   color: "#D13438",
  //                   padding: 0,
  //                   background: "#D1343833",
  //                   height: 30,
  //                   width: 30,
  //                   borderRadius: 5,
  //                   boxShadow: "0px 0px 4px 0px #00000040",
  //                 }}
  //               >
  //                 <img
  //                   style={{ height: 15, width: 15 }}
  //                   alt="delete"
  //                   src="/delete.png"
  //                 ></img>
  //               </IconButton>
  //             </>
  //           ) : (
  //             <></>
  //           )}
  //         </Box>
  //       ),
  //     }))
  //   );
  // }, [data]);

  const renderGridView = () => (
    <Grid
      sx={{
        marginTop: "1px",
        maxHeight: "100%",
        paddingBottom: 5,
        overflow: "auto",
      }}
      container
      spacing={2}
    >
      {frieightBrokerData?.map((x, index) => (
        <Grid
          sx={{ paddingBottom: 1 }}
          item
          xs={12}
          sm={6}
          md={4}
          key={`${x._id} + ${index}`}
        >
          <Card
            sx={{
              boxShadow: 3,
              cursor: "pointer",
              width: "100%",
              height: "100%",
              position: "relative",
              borderRadius: "6px",
              border: "1px solid var(--border-color)",
            }}
          >
            <CardContent>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Typography
                  fontWeight="500"
                  sx={{ textAlign: "start" }}
                  fontFamily="Poppins"
                  color="var(--text-tertiary)"
                >
                  {startIndex + index + 1}
                </Typography>
                <div
                  style={{
                    position: "absolute",
                    top: 10,
                    right: 10,
                  }}
                >
                  {x?.action}
                </div>
              </div>
              <Grid container spacing={1} mt={1}>
                <Grid item xs={5} display="flex" alignItems="center">
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily="Poppins"
                    color="var(--text-tertiary)"
                  >
                    Name
                  </Typography>
                </Grid>

                <Grid item xs={7}>
                  <Tooltip title={x?.name} arrow>
                    <Typography
                      noWrap
                      sx={{ textAlign: "start" }}
                      fontWeight="500"
                      fontFamily={"poppins"}
                      color={"var(--text-tertiary)"}
                    >
                      : {x?.name}
                    </Typography>
                  </Tooltip>
                </Grid>
                <Grid item xs={5} display={"flex"} alignItems={"center"}>
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily={"poppins"}
                    color={"var(--text-tertiary)"}
                  >
                    Address
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Tooltip title={x?.address} arrow>
                    <Typography
                      noWrap
                      sx={{ textAlign: "start" }}
                      fontWeight="500"
                      fontFamily={"poppins"}
                      color={"var(--text-tertiary)"}
                    >
                      : {x?.address}
                    </Typography>
                  </Tooltip>
                </Grid>
                <Grid item xs={5} display={"flex"} alignItems={"center"}>
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily={"poppins"}
                    color={"var(--text-tertiary)"}
                  >
                    Account No
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Tooltip title={x?.accountNo} arrow>
                    <Typography
                      noWrap
                      sx={{ textAlign: "start" }}
                      fontWeight="500"
                      fontFamily={"poppins"}
                      color={"var(--text-tertiary)"}
                    >
                      : {x?.accountNo}
                    </Typography>
                  </Tooltip>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );

  const NoDataImage = () => (
    <div
      style={{
        width: "100%",
        justifyContent: "center",
        display: "flex",
      }}
    >
      <img
        src="no_data_rateCard.png"
        alt="No data available"
        style={{ objectFit: "fill", height: "300px" }}
      />
    </div>
  );

  const MobileCardView = ({ data }) => {
    return (
      <Box sx={{ width: "100%", padding: 0.5 }}>
        {frieightBrokerData.length === 0 ? (
          <NoDataImage />
        ) : (
          frieightBrokerData?.map((x, index) => (
            <Card
              key={`${x._id} + ${index}`}
              sx={{
                marginBottom: 2,
                backgroundColor: "#ffff",
                borderRadius: 4,
              }}
            >
              <CardContent>
                <div style={{ width: "100%" }}>
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="flex-start"
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Typography
                          fontSize={14}
                          fontFamily="poppins"
                          color="var(--text-tertiary)"
                          fontWeight={600}
                          textAlign="left"
                        >
                          Name
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography
                          fontSize={14}
                          fontFamily="poppins"
                          color="#606060"
                          fontWeight={500}
                          textAlign="left"
                          noWrap
                          style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            maxWidth: "100%",
                          }}
                        >
                          : {x?.name}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography
                          fontSize={14}
                          fontFamily="poppins"
                          color="var(--text-tertiary)"
                          fontWeight={600}
                          textAlign="left"
                        >
                          Address
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography
                          fontSize={14}
                          fontFamily="poppins"
                          color="#606060"
                          fontWeight={500}
                          textAlign="left"
                          noWrap
                          style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            maxWidth: "100%",
                          }}
                        >
                          : {x?.address}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography
                          fontSize={14}
                          fontFamily="poppins"
                          color="var(--text-tertiary)"
                          fontWeight={600}
                          textAlign="left"
                        >
                          Account no
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography
                          fontSize={14}
                          fontFamily="poppins"
                          color="#606060"
                          fontWeight={500}
                          textAlign="left"
                          noWrap
                          style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            maxWidth: "100%",
                          }}
                        >
                          : {x?.accountNo}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Box>

                  <Box mt={2} justifyContent={"flex-end"} display="flex">
                    {x?.action}
                  </Box>
                </div>
              </CardContent>
            </Card>
          ))
        )}
      </Box>
    );
  };

  const renderListView = () => (
    <div
      style={{
        width: "100%",
        overflow: isMobile() ? "auto" : "hidden",
        paddingBottom: 100,
      }}
    >
      {isMobile() ? (
        renderGridView()
      ) : (
        <TableContainer
          className="custom-container"
          sx={{
            overflowY: "auto",
            paddingInline: 0.4,
            maxHeight: "100%",
            width: "100%",
          }}
        >
          <Table
            stickyHeader
            aria-label="sticky table"
            sx={{
              border: "1px solid var(--border-color)",
            }}
          >
            <TableHead>
              <StyledTableRow>
                <StyledTableCell>
                  <Typography
                    fontSize="14px"
                    color="var(--text-tertiary)"
                    fontWeight={500}
                    fontFamily={"poppins"}
                  >
                    SL NO
                  </Typography>
                </StyledTableCell>
                <StyledTableCell>
                  <Typography
                    fontSize="14px"
                    color="var(--text-tertiary)"
                    fontWeight={500}
                    fontFamily={"poppins"}
                  >
                    NAME
                  </Typography>
                </StyledTableCell>
                <StyledTableCell>
                  <Typography
                    fontSize="14px"
                    color="var(--text-tertiary)"
                    fontWeight={500}
                    fontFamily={"poppins"}
                  >
                    ADDRESS
                  </Typography>
                </StyledTableCell>
                <StyledTableCell>
                  <Typography
                    fontSize="14px"
                    color="var(--text-tertiary)"
                    fontWeight={500}
                    fontFamily={"poppins"}
                  >
                    Account No
                  </Typography>
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTypography
                    fontSize="14px"
                    title={true}
                    color="var(--text-tertiary)"
                    fontWeight={500}
                  ></CustomTypography>
                </StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {frieightBrokerData.length === 0 ? (
                <StyledTableRow>
                  <TableCell colSpan={7} align="center">
                    <NoDataImage />
                  </TableCell>
                </StyledTableRow>
              ) : (
                frieightBrokerData?.map((x, index) => (
                  <React.Fragment key={`${x._id} + ${index}`}>
                    <StyledTableRow key={`${x._id} + ${index}`}>
                      <StyledTableCell>
                        <Typography
                          fontSize="12px"
                          color="var(--text-secondary)"
                          fontWeight={400}
                          fontFamily={"Poppins"}
                        >
                          {startIndex + index + 1}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell>
                        <Typography
                          fontSize="12px"
                          color="var(--text-secondary)"
                          fontWeight={400}
                          fontFamily={"Poppins"}
                        >
                          {x?.name}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell>
                        <Typography
                          fontSize="12px"
                          color="var(--text-secondary)"
                          fontWeight={400}
                          fontFamily={"Poppins"}
                        >
                          {x?.address}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell>
                        <Typography
                          fontSize="12px"
                          color="var(--text-secondary)"
                          fontWeight={400}
                          fontFamily={"Poppins"}
                        >
                          {x?.accountNo}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell
                        sx={{ width: "3%", textAlign: "center" }}
                      >
                        {x.action}
                      </StyledTableCell>
                    </StyledTableRow>
                  </React.Fragment>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );

  return (
    <>
      <div sx={{ minWidth: "100%" }}>
        <div
          style={{
            overflowY: "scroll",
            display: "flex",
            maxHeight: "70vh",
            width: "100%",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            "&::WebkitScrollbar": { width: 0 },
          }}
        >
          {viewMode === "grid" ? renderGridView() : renderListView()}
        </div>

        <CustomPagination
          dataCount={dataCount}
          rowsPerPage={rowsPerPage}
          page={page}
          setPage={setPage}
          setRowsPerPage={setRowsPerPage}
          disableNext={dataCount <= rowsPerPage * (page + 1)}
        />
        <DeleteConfirmationModal
          DeleteConfirmationModal
          title={`Are you sure you want to delete ${selectedFreightBroker?.name} ?`}
          open={openConfirmation}
          handleClose={() => setOpenConfirmation(false)}
          handleDelete={() => {
            deleteData();
          }}
        />

        <FreightBrokerDetailsModal
          freightBroker={selectedFreightBroker}
          open={openViewModal}
          onClose={() => setOpenViewModal(false)}
        />
      </div>
    </>
  );
};

export default FreightBrokerList;
